import React, { useEffect } from 'react';
import './BottomSheet.css';

const BottomSheet = ({ isOpen, toggleBottomSheet, setView }) => {
  useEffect(() => {
    const bottomSheetElement = document.querySelector('.bottom-sheet');
    if (!isOpen) {
      bottomSheetElement.style.bottom = '78px';
    } else {
      bottomSheetElement.style.bottom = '56px';
    }
  }, [isOpen]);

  const handleButtonClick = (coordinates) => {
    setView(coordinates, 11.9); // Call setView with coordinates and zoom level
  };

  return (
    <div className={`bottom-sheet ${isOpen ? 'open' : 'closed'}`} onClick={toggleBottomSheet}>
      <div className="bottom-sheet-handle"></div>
      <div className="tap-to-open">Special Stages</div>
      <div className="bottom-sheet-content" onClick={(e) => e.stopPropagation()}>
        <button onClick={() => handleButtonClick([-6.199110815251231, 54.14389937916687])}>SS 1 & 4</button>
        <button onClick={() => handleButtonClick([-6.4325056463666215, 54.15515966663892])}>SS 2 & 5</button>
        <button onClick={() => handleButtonClick([-6.437817026700941, 54.114589531140865])}>SS 3 & 6</button>
        <button onClick={() => handleButtonClick([-6.30783794384331, 54.359262979704425])}>SS 7 & 10</button>
        <button onClick={() => handleButtonClick([-6.244470965587681, 54.38568583353276])}>SS 8 & 11</button>
        <button onClick={() => handleButtonClick([-6.221947464657546, 54.29729727013202])}>SS 9 & 12</button>
      </div>
    </div>
  );
};

export default BottomSheet;